module.exports = __webpack_public_path__ + "static/img/10.1aedaa09.png";